
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_49085","data-name":"Group 49085","transform":"translate(-11 -88)"}},[_c('rect',{attrs:{"id":"Rectangle_16687","data-name":"Rectangle 16687","width":"30","height":"30","rx":"9","transform":"translate(11 88)","fill":"#e0e0fe","opacity":".549"}}),_c('g',{attrs:{"id":"Group_49037","data-name":"Group 49037"}},[_c('path',{attrs:{"id":"Path_38391","data-name":"Path 38391","d":"M26.001 106.956v-4.776m0 0a5.467 5.467 0 001.364-.172m-1.364.172a5.467 5.467 0 01-1.364-.172m3.411 7.8a10.97 10.97 0 01-4.093 0m3.411 2.6a13.1 13.1 0 01-2.729 0m3.411-5.454v-.175a2.531 2.531 0 011.372-2.107 6.822 6.822 0 10-6.838 0 2.532 2.532 0 011.373 2.107v.175","fill":"none","stroke":"#7367ff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])
          )
        }
      }
    